import { Injectable } from "@angular/core";
import { HttpService } from "src/app/utils/http-service.service";

@Injectable({
  providedIn: 'root'
})

export class EmpresaService {
  constructor(private service: HttpService) { }

  novaEmpresa(params) {
    return this.service.sendPost(`admin/empresas`, params);
  }

  updateEmpresa(id, params) {
    return this.service.sendPatch(`admin/empresas/${id}`, params);
  }

  buscaEmpresa(id) {
    return this.service.sendGet(`admin/empresas/${id}`);
  }

  getEmpresaByCnpj(params) {
    return this.service.sendGet(`admin/empresas/cnpj/${params.cnpj}`);
  }
}
